// import inertiaItem from './inertia-item'
import { Col } from '../grid'

export default {
  name: 'KListItemWrap',
  // mixins: [inertiaItem],
  inject: ['context'],
  props: {
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    grid() {
      return this.context.grid
    },
    // hasWrapper() {
    //   return this.context.inertia === true
    // },
  },
  methods: {},
  render() {
    if (this.grid) {
      const weight = Math.abs(24 / (this.grid.column || 1))
      return <Col
        weight={weight}
      >
        {this.$slots.default}
      </Col>
    }
    return this.$slots.default
    // if (!this.hasWrapper) {
    // }

    // return <div
    //   class="km-list-item__wrapper"
    //   style={this.transform}
    // >
    //   <div>
    //     transformY: {this.translateY} - scrollAmount: {this.scrollAmount}
    //   </div>
    //   <div>
    //     delay: {this.delay}
    //   </div>
    //   <div>
    //     speed: {this.speed}
    //   </div>
    //   <div>
    //     diffWithContainerScrollPosition: {this.diffWithContainerScrollPosition}
    //   </div>
    //   <div>
    //     scrollingReferenceIndex: {this.scrollingReferenceIndex} - currentIndex: {this.index}
    //   </div>
    //   <div>
    //     isScrollingDown: {this.isScrollingDown ? 'Yes' : 'No'}
    //   </div>
    //
    //   {
    //     this.$slots.default
    //   }
    // </div>
  },
}
